import React from 'react';
import classes from './availableIcon.css';
import { Check, Info, XCircle, HelpCircle } from 'react-feather';
import Icon from '@magento/venia-ui/lib/components/Icon';
var AvailableIcon = _ref => {
  var {
    type,
    stepValue,
    style
  } = _ref;
  var icon;
  var usedClass;
  switch (type) {
    case 'check':
      icon = Check;
      usedClass = classes.availableIcon;
      break;
    case 'step':
      usedClass = classes.step;
      break;
    case 'unstep':
      usedClass = classes.unstep;
      break;
    case 'alert':
      icon = Info;
      usedClass = classes.alertIcon;
      break;
    case 'unavailable':
      icon = XCircle;
      usedClass = classes.alertIcon;
      break;
    case 'help':
      icon = HelpCircle;
      usedClass = classes.normalIcon;
      break;
    default:
      icon = Check;
      usedClass = classes.availableIcon;
      break;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: usedClass,
    style: style
  }, type === 'step' || type === 'unstep' ? /*#__PURE__*/React.createElement("p", null, stepValue) : /*#__PURE__*/React.createElement(Icon, {
    src: icon
  }));
};
export default AvailableIcon;